import httpRequest, { ApiConfig, httpAnonymousRequest } from 'httpRequest'
import {
    CountryContract,
    LocationContract,
    LocationSettingContract,
    LocationSubDomainInfo,
    UpdateLocationBasicInfoContract,
} from 'models'

const LOCATIONS_PREFIX = '/locations'
const LOCATION_PREFIX = '/location'

const locationService = {
    getLocations: (config?: ApiConfig) =>
        httpRequest.get<LocationContract[]>(`${LOCATIONS_PREFIX}`, config),
    createLocation: (location: LocationContract) =>
        httpRequest.post<string>(`${LOCATIONS_PREFIX}`, location),

    deleteLocation: (locationIds: string[]) =>
        httpRequest.delete(`${LOCATIONS_PREFIX}`, { params: { locationIds } }),

    getLocationById: (locationId: string) =>
        httpRequest.get<LocationContract>(`${LOCATIONS_PREFIX}/${locationId}`),

    updateLocation: (locationId: string, payload: LocationContract) =>
        httpRequest.put(`${LOCATIONS_PREFIX}/${locationId}`, payload),
    deleteLocations: (locationIds: string[]) =>
        httpRequest.delete(LOCATIONS_PREFIX, { params: { locationIds } }),

    getCurrentLocation() {
        return httpRequest.get<LocationContract>(`${LOCATION_PREFIX}`)
    },

    getLocationSettingOfCurrentUser(includeRemovedLocations?: boolean) {
        return httpRequest.get<LocationSettingContract>(
            `${LOCATION_PREFIX}/location-setting?includeRemovedLocations=${
                includeRemovedLocations ?? false
            }`,
        )
    },

    getCurrentUserCountry() {
        return httpAnonymousRequest.get<CountryContract>(
            `${LOCATION_PREFIX}/country`,
        )
    },
    updateLocationBaseInfo: (payload: UpdateLocationBasicInfoContract) =>
        httpRequest.put(`${LOCATION_PREFIX}/base-info`, payload),
    getLocationsSubDomain() {
        return httpRequest.get<LocationSubDomainInfo[]>(
            `/company${LOCATIONS_PREFIX}/sub-domain`,
        )
    },
    resetSalesData() {
        return httpRequest.post(`${LOCATION_PREFIX}/reset-sales`)
    },
    undeleteLocation(locationID: string) {
        return httpRequest.post(`${LOCATIONS_PREFIX}/undelete/${locationID}`)
    },
    permanentlyDeleteLocation(locationID: string) {
        return httpRequest.delete(
            `${LOCATIONS_PREFIX}/permanently-delete/${locationID}`,
        )
    },
}

export default locationService
